<!--
 * @Description: ''
 * @Author: yangruonan(yangruonan@hztianque.com)
 * @Date: 2021-04-28 16:29:55
 * @LastEditTime: 2021-05-08 15:02:32
-->
<template>
  <div class="inventory-mask">
    <Modal
      v-model="showInventoryModel"
      :mask-closable="false"
      title="修改库存"
      @on-cancel="cancelModel">
      <Form
        ref="formInventory"
        :model="formInventory"
        :label-width="0"
        value="1"
        :rules="ruleValidate">
        <Row>
          <Col span="6">
            <FormItem label="" prop="type">
              <Select v-model="formInventory.type">
                <Option
                  v-for="item in editList"
                  :value="item.value"
                  :key="item.value">
                  {{item.label}}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="1" />
          <Col span="17">
            <FormItem label="" prop="num">
              <Input
                v-model="formInventory.num"
                type="number"
                placeholder="请输入正整数"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="cancelModel">取消</Button>
        <Button type="primary" :loading="loading" @click="asyncSaveOK('formInventory')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
    showInventory: {
      type: Boolean,
      default: false,
    },
    formValidate: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showInventoryModel: this.showInventory,
      formInventory: {
        type: 1,
      },
      ruleValidate: {
        num: [
          { required: true, message: '请输入正整数', trigger: 'blur,change' },
          {
            // eslint-disable-next-line no-unused-vars
            validator: (rule, value, callback) => {
              const reg = /^\+?[1-9][0-9]*$/ //正整数
              if (reg.test(value)) {
                if (Number(value) > 99999) {
                  callback('库存不能大于99999')
                } else {
                  callback()
                }
              } else {
                callback('请输入正整数')
              }
            },
            trigger: 'blur,change',
          },
        ],
      },
      editList: [
        {
          value: 1,
          label: '增加',
        },
        {
          value: 2,
          label: '减少',
        },
      ],
      loading: false,
    }
  },
  watch: {
    showInventory(val) {
      this.showInventoryModel = val
    },
  },
  methods: {
    // 关闭
    cancelModel() {
      this.showInventoryModel = false
      this.$refs['formInventory'].resetFields()
      this.$emit('showModel', false)
    },
    // 确定
    asyncSaveOK(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          let stock = Number(this.formInventory.num)
          // eslint-disable-next-line no-const-assign
          if (this.formInventory.type === 2) {
            if (this.formValidate.stock < this.formInventory.num) {
              this.$Message.error('酒店剩余库存不足!')
              this.loading = false
              return
            }
            stock = 0 - this.formInventory.num
          }
          this.updateStock({stock: stock, id: this.id}).then(res => {//eslint-disable-line
            if (res.code === '0' && res.flag === '0') {
              this.$Message.success('修改成功!')
              this.$emit('showModel', { modal: false, type: 'update' })
              this.loading = false
              this.cancelModel()
            }
          }).catch(err => {
            this.$Message.error(err.message)
          })
        }
      })


      // let stock = Number(this.formInventory.num)
      // // eslint-disable-next-line no-const-assign
      // if (this.formInventory.type === 2) { stock = 0 - this.formInventory.num }
      // await this.updateStock({stock: stock, id: this.id}).then(res => {//eslint-disable-line
      //   if (res.code === '0' && res.flag === '0') {
      //     this.$Message.success('修改成功!')
      //     this.cancelModel()
      //     this.$emit('showModel', { modal: false, type: 'update' })
      //   }
      // }).catch(err => {
      //   this.$Message.error(err.message)
      // })
    },
    ...mapActions({
      updateStock: 'jurisprudenceDaily/hotelManagement/updateStock',
    }),
  },
}
</script>
<style lang="scss" scoped>

</style>